import { ChangeDetectionStrategy, Component, forwardRef, Type } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { TextboxComponent } from "@shared/textbox/textbox.component";

@Component({
	selector: "app-passwordbox",
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		multi: true,
		useExisting: forwardRef((): Type<PasswordboxComponent> => PasswordboxComponent)
	}],
	template: `
		<div class="password">
      		<input
				#input
				[type]="showPassword ? 'text' : 'password'"
				[class.error]="showError"
        		[value]="value"
				(input)="onInput(input.value)"
				placeholder="{{ placeholder }}"
				[autocomplete]="autocomplete">
					<app-icon (click)="showPassword = !showPassword">
						{{ !showPassword ? "visibility" : "visibility_off" }}
					</app-icon>
		</div>`,
	styleUrls: ["./passwordbox.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordboxComponent extends TextboxComponent {
	public showPassword = false;
}
